import { ClickNavigationSection } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { RightCapitalContactSyncSettings } from './RightCapitalContactSyncSettings'

export const RightCapitalSpecificSettings = (): ClickNavigationSection[] => {
  return [{ id: 'contactSync', label: 'Contact Sync', content: () => <RightCapitalContactSyncSettings /> }]
}
